export default "__VITE_ASSET__Dg1U1gjv__"